import {
  activeFlagColumnDefinition,
  assignmentTypeColumnDefinition,
  assignmentsUsersColumnDefinition,
  emailColumnDefinition,
  firstNameColumnDefinition,
  lastNameColumnDefinition,
  privilegesColumnDefinition,
  roleClientColumnDefinition,
  ssoColumnDefinition,
  userRoleColumnDefinition,
  expirationDateColumnDefinition,
} from '../columnDefinitions';

const usersAndPrivilegesColumnDefinitions = [
  emailColumnDefinition,
  firstNameColumnDefinition,
  lastNameColumnDefinition,
  ssoColumnDefinition,
  roleClientColumnDefinition,
  activeFlagColumnDefinition,
  {
    ...userRoleColumnDefinition,
    headerName: 'User Role',
  },
  {
    ...expirationDateColumnDefinition,
    headerName: 'Expiration Date',
  },
  {
    ...privilegesColumnDefinition,
    headerName: 'Privilege',
  },
  assignmentTypeColumnDefinition,
  {
    ...assignmentsUsersColumnDefinition,
    headerName: 'Assignment',
  },
];

export default usersAndPrivilegesColumnDefinitions;
